/* eslint-disable jsx-a11y/label-has-associated-control */

import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";

import {
    Box,
    Card,
    Grid,
    Container,
    CardContent,
    CardActions,
    Typography,
} from "@mui/material";

import useForm from "../../hooks/validation";
import { styles } from "./style";
import Iconify from "../../components/iconify/iconify";
import LoadingButton from "../../shared/loadingButton/LoadingButton";
import { placeholderStye } from "../../theme/style";
import MuiTextField from "../../theme/TextField";
import boardServices from "../../services/boardServices";
import useFetchData from "../../hooks/fetchData";
import tributeServices from "../../services/tributeServices";
import ImageWithFallback from "../../components/ImageWithFallback";
import { getErrorMessage } from "../../utils";
import RichTextEditor from "../../components/RichTextEditor";



const validationRules = {
    description: (value) => (value ? "" : "This field is required"),
    shortStatement: (value) => (value ? "" : "This field is required"),


};
const EditTribute = () => {
    const navigate = useNavigate();

    const { id } = useParams();
    const { data: board, loading: boardLoading } = useFetchData(tributeServices.getByID, id);
    const initialValues = {
        description: (!boardLoading && board?.description) || '',
        shortStatement: (!boardLoading && board?.shortStatement) || '',





    };

    const { values, errors, handleOnChange, validateAllFields, setFormValues } =
        useForm(initialValues, validationRules);

    const [memberImage, setMemberImage] = useState((!boardLoading && board?.image) || '');



    useEffect(() => {
        setFormValues(initialValues);
        setMemberImage((!boardLoading && board?.image) || '');


    }, [board]);

    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];


        setMemberImage(file);
    };

    const handleRichTextChange = (content, fieldName) => {
        handleOnChange({ target: { name: fieldName, value: content } });
    };

    const handleSubmit = async () => {
        const dataToSend = {
            ...values,
            image: memberImage,
        };
        if (validateAllFields()) {
            setIsLoading(true)
            tributeServices
                .edit(dataToSend, id)
                .then(() => {
                    toast.success("Tribute updated successfully")
                    navigate(-1)
                    setIsLoading(false)
                })
                .catch((err) => {
                    toast.error(getErrorMessage(err))
                    setIsLoading(false)
                });
        }

    };

    return (
        <Container>
            <Card sx={{ padding: "1rem" }}>
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Box sx={{ ...styles.mainWrapper, ...(!memberImage && { maxWidth: "100%", width: "100%" }) }}>
                                <input
                                    type="file"
                                    name="staffProfileImage"
                                    id="staff_profile_img"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    onChange={handleFileChange}
                                />
                                {memberImage ? (
                                    <Box sx={styles.imagePreviewBlock}>
                                        <Box sx={styles.imageWrapper}>
                                            <Box sx={{ width: "100%", height: "100%" }}>
                                                {typeof memberImage === "object" && memberImage instanceof File ? (
                                                    <img
                                                        height="100%"
                                                        width="100%"
                                                        style={{ objectFit: "cover" }}
                                                        src={URL.createObjectURL(memberImage)}
                                                        alt="Tribute"
                                                    />
                                                ) : (
                                                    <ImageWithFallback
                                                        path={memberImage}
                                                        alt="Tribute"
                                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                    />
                                                )}
                                            </Box>
                                        </Box>
                                        <label htmlFor="staff_profile_img">
                                            <Typography
                                                component="span"
                                                variant="caption"
                                                sx={styles.changeImageLink}
                                            >
                                                <Iconify icon="eva:edit-2-outline" sx={{ width: 14, height: 14, mr: 0.5, verticalAlign: "middle" }} />
                                                Change image
                                            </Typography>
                                        </label>
                                    </Box>
                                ) : (
                                    <label
                                        htmlFor="staff_profile_img"
                                        style={{ cursor: "pointer", display: "block" }}
                                    >
                                        <Box sx={[styles.imageWrapper, styles.imageWrapperEmpty]}>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    fontWeight: 700,
                                                    color: "#495057",
                                                    textAlign: "center",
                                                    lineHeight: 1.3,
                                                }}
                                            >
                                                Click here
                                            </Typography>
                                            <Typography
                                                variant="caption"
                                                sx={{
                                                    fontWeight: 600,
                                                    color: "#495057",
                                                    textAlign: "center",
                                                    mt: 0.5,
                                                }}
                                            >
                                                to add image
                                            </Typography>
                                        </Box>
                                    </label>
                                )}
                            </Box>
                        </Grid>

                        {/* <Grid item xs={12}>
                            <MuiTextField
                                label="name"
                                name="name"
                                value={values.name}
                                error={errors.name}
                                helperText={errors.name}
                                onChange={handleOnChange}
                                inputProps={placeholderStye}
                                placeholder="Name"
                            />
                        </Grid> */}
                        <Grid item xs={12}>
                            <MuiTextField
                                label="short description"
                                name="shortStatement"
                                value={values.shortStatement}
                                error={errors.shortStatement}
                                helperText={errors.shortStatement}
                                onChange={handleOnChange}
                                inputProps={placeholderStye}
                                placeholder="short description"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <RichTextEditor
                                label="Description"
                                value={values.description}
                                onChange={(content) => handleRichTextChange(content, "description")}
                                error={errors.description}
                                placeholder="Enter detailed description"
                            />
                        </Grid>
                    </Grid>
                </CardContent>
                <CardActions>
                    <LoadingButton
                        isLoading={isLoading}
                        variant="contained"
                        onClick={handleSubmit}
                    >
                        Update Tributes
                    </LoadingButton>
                </CardActions>
            </Card>
        </Container>
    );
};

export default EditTribute;
